import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import RadioGroup from '../common/RadioGroup';
import { Card, Header, Body, BoldTitle, GreyText, HorizontalDivider } from '../common/Card';

const RentersInsuranceCard = ({ values, setFieldValue }) => {
  return (
    <Card>
      <Header>
        <BoldTitle>
          {getTranslatedString('landlordPortal.rentRoll.renewals.insuranceRequired')}
        </BoldTitle>
      </Header>
      <HorizontalDivider />
      <Body>
        <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.insuranceHelp')}</GreyText>
      </Body>
      <Body>
        <RadioGroup
          name={'insurance_required'}
          value={values.insurance_required}
          onChange={val => setFieldValue('insurance_required', val)}
        />
      </Body>
    </Card>
  );
};

export default RentersInsuranceCard;
